"use client"

import { motion } from "framer-motion"
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaGlobe,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
} from "react-icons/fa"

const ContactoBufete = ({ data }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="grid grid-cols-1 md:grid-cols-2 gap-8"
    >
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold mb-6">Información de Contacto</h2>

        <div className="space-y-4">
          <div className="flex items-start space-x-4">
            <FaMapMarkerAlt className="text-[var(--gold)] text-xl mt-1" />
            <div>
              <h3 className="font-semibold">Dirección</h3>
              <p className="text-gray-600">{data.direccion}</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <FaPhone className="text-[var(--gold)] text-xl mt-1" />
            <div>
              <h3 className="font-semibold">Teléfono</h3>
              <p className="text-gray-600">+34 91 123 4567</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <FaEnvelope className="text-[var(--gold)] text-xl mt-1" />
            <div>
              <h3 className="font-semibold">Email</h3>
              <p className="text-gray-600">contacto@bufetegarcia.com</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <FaClock className="text-[var(--gold)] text-xl mt-1" />
            <div>
              <h3 className="font-semibold">Horario</h3>
              <p className="text-gray-600">Lunes a Viernes: 9:00 - 18:00</p>
              <p className="text-gray-600">Sábados: Con cita previa</p>
            </div>
          </div>
        </div>

        <div className="mt-6">
          <h3 className="font-semibold mb-4">Redes Sociales</h3>
          <div className="flex space-x-4">
            <a href="#" className="text-[var(--gold)] hover:text-[var(--gold-dark)] ">
              <FaLinkedin className="text-2xl" />
            </a>
            <a href="#" className="text-[var(--gold)] hover:text-[var(--gold-dark)] ">
              <FaTwitter className="text-2xl" />
            </a>
            <a href="#" className="text-[var(--gold)] hover:text-[var(--gold-dark)] ">
              <FaFacebook className="text-2xl" />
            </a>
            <a href="#" className="text-[var(--gold)] hover:text-[var(--gold-dark)] ">
              <FaGlobe className="text-2xl" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold mb-6">Envíanos un mensaje</h2>

        <form className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nombre completo</label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold-dark)] "
              placeholder="Tu nombre"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold-dark)] "
              placeholder="tu@email.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Asunto</label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold-dark)] "
              placeholder="Asunto de tu mensaje"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Mensaje</label>
            <textarea
              rows="4"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold-dark)] "
              placeholder="Escribe tu mensaje aquí..."
            ></textarea>
          </div>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="w-full px-6 py-3 bg-[var(--gold)] text-white rounded-lg hover:bg-[var(--gold-dark)]  transition-colors"
            type="submit"
          >
            Enviar mensaje
          </motion.button>
        </form>
      </div>
    </motion.div>
  )
}

export default ContactoBufete

